module.exports = __webpack_public_path__ + "img/facebook.238182e6.svg";